/* DateUtil.js */

"use strict";

class DateUtil {
    static getTimeDifferenceStr(startTimeInMillisec, endTimeInMillisec) {
        if (
            !startTimeInMillisec ||
            !endTimeInMillisec ||
            isNaN(startTimeInMillisec) ||
            isNaN(endTimeInMillisec) ||
            startTimeInMillisec > endTimeInMillisec
        ) {
            return "";
        }
        let timeDiff = endTimeInMillisec - startTimeInMillisec;
        let hoursPassed = Math.floor(timeDiff / (1000 * 60 * 60));
        let minutesPassed = Math.floor(timeDiff / (1000 * 60)) % 60;
        let secondsPassed = Math.floor(timeDiff / 1000) % 60;
        let milliSecondsPassed = timeDiff % 1000;
        let timePassed = hoursPassed > 0 ? (hoursPassed + ":").padStart(3, 0) : "";
        timePassed =
            timePassed +
            (minutesPassed > 0 ? (minutesPassed + ":").padStart(3, "0") : timePassed ? "00:" : "");
        timePassed = timePassed + (secondsPassed + ".").padStart(3, "0");
        timePassed = timePassed + (milliSecondsPassed + "").padStart(3, "0");
        return timePassed;
    }
}

module.exports = DateUtil;
